//Переводит в нижний регистр все строки, кроме тех, которые состоят только из
//символов в верхнем регистре
//например ОГРН останется в верхнем регистре

exports.toFormLowerCase = function(str) {
    if(str.toUpperCase() === str) {
        return str
    }
    return str.toLowerCase()
}

exports.errorMessage = function(error) {
    if (error.response?.data?.errors?.sign) {
        return error.response.data.errors.sign[0]
    } else if(error.response?.status === 413 ) {
        return 'Размер файла не может превышать 10 МБ'
    } else {
        const validationErrors = error.response?.data?.errors ? Object.values(error.response?.data?.errors).flat() : null
        return validationErrors || error.response?.data?.message || error.message || 'Неизвестная ошибка'
    }
}
